<template>
  <a class="sponsor"
     :href="sponsor.link">
    <div class="row">
      <div class="col-4 p-0">
        <img loading="lazy" sizes="100%, 100%" :title="sponsor.title" :alt="sponsor.title" class="img-fluid"
             :src="sponsor.icon">
      </div>
      <div class="col-8 p-0 sponsor-name">
        <span>{{sponsor.title}}</span>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    name: "Sponsor",
    props: {
      sponsor: {
        type: Object,
        required: true,
      }
    }
  }
</script>

<style scoped>

  .sponsor-name {
    font-family: 'RuneScape UF', sans-serif;
    text-align: left;
    font-size: 0.8rem;
    line-height: 0.8rem;
    /*font-weight: bold;*/
  }

  a {
    color: black;
  }

  a:hover {
    color: #dbcba3;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sponsor.vue